import { Section } from '../../Section';

export const getSectionDisplayedSurface = (section: Section) =>
  section.displayedSurface ? section.displayedSurface : 0;
